import React, { useState, useEffect } from "react";
import AppBrand from "../../common/AppBrand";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useGoogleLogin } from "@react-oauth/google";
import GoogleUsersModal from "./GoogleUsersModal";
import {
  axios_instance,
  updateAxiosHeaders,
} from "../../../api/axios_instance";
import {
  decryptRequest,
  encryptRequest,
} from "../../../utils/encryptdecryptrequest";
import { getCsrfToken } from "../../../api/csrf_token";

const GoogleLoginPage = () => {
  const [showGoogleUsersModal, setShowGoogleUsersModal] = useState([false, []]);
  const [errorMsg, setErrorMsg] = useState([false, ""]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userToken = localStorage.token;

  useEffect(() => {
    if (userToken) return navigate("/payments/disbursement_list");
  }, [userToken, navigate]);

  useEffect(function () {
    getCsrfToken();
  }, []);

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      try {
        let reqData = encryptRequest({ access_token: response.access_token });
        let result = await axios_instance({
          url: "/verify_google_login",
          method: "POST",
          data: { reqData },
        });
        let resData = decryptRequest(result.data.resData);

        const users = resData.users;

        if (users.length === 0) return;

        if (users.length === 1) {
          reqData = encryptRequest({ username: users[0].username });
          result = await axios_instance({
            url: "/googleLoginByUsername",
            method: "POST",
            data: { reqData },
          });

          resData = decryptRequest(result.data.resData);

          const user = resData.user;
          user.token = resData.token;
          user.menuVisibilityObj = resData.menuVisibilityObj;

          dispatch({ type: "add_user", payload: user });
          localStorage.setItem("token", resData.token);
          updateAxiosHeaders();
          navigate("/payments/disbursement_list");
          return;
        }

        setShowGoogleUsersModal([true, users]);
      } catch (e) {
        const msg = e?.response?.data?.message
          ? e.response.data.message
          : e.message;
        setErrorMsg([true, msg]);
      }
    },
  });

  const closeGoogleUsersModal = () =>
    setShowGoogleUsersModal([false, showGoogleUsersModal[1]]);

  return (
    <span>
      {showGoogleUsersModal[0] && (
        <GoogleUsersModal
          users={showGoogleUsersModal[1]}
          setErrorMsg={setErrorMsg}
          closeGoogleUsersModal={closeGoogleUsersModal}
        ></GoogleUsersModal>
      )}
      <div className="container-fluid">
        <div className="row">
          <div className="login-box">
            <div className="login_logo">
              <AppBrand className="app-brand--login" />
            </div>
            <div className="fcm-login_box">
              <div className="fcm-login_header">
                <h2 className="head_txt"> Login</h2>
              </div>

              <div className="fcm-login_body clearfix">
                {errorMsg[0] ? (
                  <span
                    role="alert"
                    className="error-msg-login userId-valid google-login-error-span"
                  >
                    {errorMsg[1]}
                  </span>
                ) : (
                  ""
                )}
                <div className="col-md-12 mrg-T10">
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <a
                        href="/#"
                        onClick={() => login()}
                        className="goole_login"
                        type="button"
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          style={{
                            marginRight: "10px",
                            background: "rgb(255, 255, 255)",
                            padding: "10px",
                            borderRadius: "2px",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g fill="#000" fillRule="evenodd">
                              <path
                                d="M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z"
                                fill="#EA4335"
                              ></path>
                              <path
                                d="M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z"
                                fill="#4285F4"
                              ></path>
                              <path
                                d="M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z"
                                fill="#FBBC05"
                              ></path>
                              <path
                                d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z"
                                fill="#34A853"
                              ></path>
                              <path fill="none" d="M0 0h18v18H0z"></path>
                            </g>
                          </svg>
                        </div>
                        <span
                          style={{
                            padding: "10px 10px 10px 0px",
                            fontWeight: "500",
                          }}
                        >
                          Login with Google
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 mrg-T10">
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <p>
                        <br />
                        {+process.env.REACT_APP_DISABLE_MANUAL_LOGIN ? (
                          ""
                        ) : (
                          <Link to="manuallogin">
                            <button className="manual-login-btn">
                              Do not have google login?
                            </button>
                          </Link>
                        )}
                      </p>
                    </div>
                    <div className="col-md-5 text-right"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </span>
  );
};

export default GoogleLoginPage;
